import { render, staticRenderFns } from "./oapp-main.vue?vue&type=template&id=59d1be20&"
import script from "./oapp-main.vue?vue&type=script&lang=js&"
export * from "./oapp-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports